import React from 'react'
// import { AppButton } from '../../Components/index.js'
import { useStyles } from './style.js'

const Error404 = (props) => {
  const classes = useStyles()
  return (
    <div className={classes.headerWrapper}>
      <div className={classes.title}>404</div>
      <div className={classes.content}>
        Oops, an error has occurred. Page not found!
      </div>
      {/* <AppButton text="Go to Home" onClick={() => props.history.push('/dashboard')} /> */}
    </div>
  )
}

export default Error404
